import { Injectable } from '@angular/core';
import { AlertService } from './alert.service';
import { GlobalesService } from './globales.service';
import { MainService } from '../api/main.service';

@Injectable({
  providedIn: 'root'
})
export class VersionesService {

  //#region Constructor

  constructor(
    private alertService: AlertService,
    private globales: GlobalesService,
    private service: MainService
  ) { }

  //#endregion

  //#region Comprobación de si se ha actualizado.

  public async checkAppUpdated(): Promise<string> {

    let changeLog: string = ''

    // Obtener la última versión que se utilizó de la aplicación
    let ultimaVersionUtilizada = localStorage.getItem('appVersion')

    // Obtener la versión actual
    let versionActual = this.globales.version

    if (ultimaVersionUtilizada != null && ultimaVersionUtilizada != '' && versionActual != ultimaVersionUtilizada) {
      
      // Tenemos una versión nueva, tenemos que mostrar el ChangeLog
      try {

        changeLog = await this.service.Versiones.getDescripcion(versionActual)
        
      } catch (ex) {
        // Si falla, probablemente no estemos autenticados, y por tanto seguramente no sea relevante el hecho de que se ha actualizado la aplicación para un usuari
        // que aún no la ha utilizado.
      }

    }

    // Actualizar la versión que se utilizó de la aplicación
    localStorage.setItem('appVersion', versionActual)

    return changeLog

  }

  //#endregion

}
